<!--
 * @Author: your name
 * @Date: 2020-12-22 17:55:29
 * @LastEditTime: 2021-03-16 14:59:58
 * @LastEditors: Please set LastEditors
 * @Description: 日期选择组件
 * @FilePath: /hsylc2021/src/components/form/DatePicker/datePicker.vue
-->
<template>
  <div class="component-datePicker" @mouseover="changeEventHandler" @mouseout="changeEventHandler">
    <div class="component-datePicker-wrap">
      <CheckInput
        class="input-datePicker noevent z2"
        :isFocus="inputFocus"
        :isHover="inputHover"
        :label="label"
        :placeholder="placeholder"
        v-model="inputVal"
        :disabled="disable"
        :error="error"
        :isCheck="false"
      />

      <div class="datePicker-icon z2" :class="disable ? 'on' : ''"></div>
      <el-date-picker
        class="el-datePicker overlay"
        v-model="dateVal"
        :value-format="valFormat"
        :type="type"
        placeholder="选择日期"
        @focus="changeEventHandler"
        @change="onSelectChange"
        @blur="changeEventHandler"
        :disabled="disable"
      >
      </el-date-picker>
      <div v-if="(startVerific && error) || error" class="errmsg">{{ errmsg }}</div>
    </div>
  </div>
</template>
<script>
import CheckInput from '../CheckInput/checkInput';

/**
 * 日期选择组件
 * @module DatePicker
 */
export default {
  name: 'DatePicker',
  /**
   * @prop {Boolean} disable 是否禁用状态 默认false
   * @prop {Boolean} error 是否错误状态 默认false
   * @prop {String} type 日期选择类型 date-到天 month-到月 默认date
   * @prop {String} value 默认值 2014-01-01
   * @prop {String} valFormat 日期格式 默认yyyy-dd-mm
   */
  props: {
    label: {
      type: String,
      default: '生日'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'date'
    },
    default: {
      type: String,
      default: '2005-01-01'
    },
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    valFormat: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    errmsg: {
      type: String,
      default: '请选择'
    }
  },
  /**
   * @prop {Component} Input 输入组件
   */
  components: {
    CheckInput
  },
  /**
   * @prop {Boolean} inputHover 输入框是否鼠标覆盖状态
   * @prop {Boolean} inputFocus 输入框是否focus状态
   * @prop {String} inputVal input默认值
   * @prop {String} value 组件默认值
   */
  data() {
    return {
      inputHover: false,
      inputFocus: false,
      inputVal: this.value ? this.value : '',
      error: false, // 选择框报错状态

      dateVal: this.value ? this.value : this.default ? this.default : '2005-01-01'
      // value: ''
    };
  },
  watch: {
    startVerific() {
      if (this.startVerific) {
        this.error = this.inputVal === '' ? true : false;
      }
    },
    // 初始化 填入数据 由于有时间差 所以需要 监听
    value() {
      this.inputVal = this.value ? this.value : '';
      this.dateVal = this.value ? this.value : this.default ? this.default : '2005-01-01';
      if (this.startVerific) {
        this.error = this.inputVal === '' ? true : false;
      }
    }
  },
  mounted() {
    // console.log(this.inputVal);
    if (this.startVerific) {
      this.error = this.inputVal === '' ? true : false;
    }
  },
  methods: {
    /**
     * @description 监听 按钮状态 切换背景颜色
     * @function changeEventHandler
     * @param {Object} event 事件对象
     */
    changeEventHandler(event) {
      // if (this.inputType == 'disabled') return;
      const that = this;
      let eventType = event.type;
      // console.log(eventType);
      // let result = '';
      switch (eventType) {
        case 'mouseover':
          if (that.error) return;
          if (that.disable) return;
          that.inputHover = true;
          break;
        case 'mouseout':
          if (that.inputFocus) return;
          if (that.error) return;
          if (that.disable) return;
          // that.inputFocus = false;
          that.inputHover = false;
          break;
        case 'focus':
          if (that.error) return;
          that.focusHandler();
          break;
        case 'blur':
          that.inputFocus = false;
          console.log('blur');
          break;
        case 'date':
          console.log('data:', this.dateVal);
          this.inputVal = this.dateVal;
          this.onSelectChange(this.inputVal);
          that.focusHandler();
          break;
        case 'month':
          if (that.error) return;
          that.focusHandler();
          break;
        default:
          break;
      }
      // this.inputType = result;
    },
    /**
     * @description focus事件
     * @function focusHandler
     */
    focusHandler() {
      this.inputFocus = true;
    },
    // 检验 选项框 是否为空 否则报错
    checkSelectInput() {
      this.error = this.inputVal === '' ? true : false;
      this.$emit('blur', this.error, this.id, this.errmsg);
    },
    /**
     * @event change 暴漏change事件
     */
    /**
     * @description 选项修改事件
     * @function onSelectChange
     * @param {String} val 选择值
     */
    onSelectChange(val) {
      this.inputVal = val;
      this.$emit('input', val);
      this.$emit('change', val);
      this.checkSelectInput();

      if (this.error) return;
      this.inputFocus = val === '' ? false : true;
    }
  }
};
</script>
<style lang="less">
.el-picker-panel .el-picker-panel__body-wrapper .el-picker-panel__body .el-picker-panel__content .el-date-table td.current:not(.disabled) span {
  background-color: @color-A11A22 !important;
  color: @color-FFF !important;
}
.el-picker-panel .el-picker-panel__body-wrapper .el-picker-panel__body .el-picker-panel__content .el-date-table td:hover {
  color: @color-A11A22 !important;
}
.el-picker-panel .el-picker-panel__body-wrapper .el-picker-panel__body .el-date-picker__header .el-picker-panel__icon-btn:hover {
  color: @color-A11A22 !important;
}

.el-picker-panel .el-picker-panel__body-wrapper .el-picker-panel__body .el-date-picker__header .el-date-picker__header-label:hover {
  color: @color-A11A22 !important;
}
</style>
<style lang="less" src="./datePicker.less" scoped></style>
